"use strict";
var elementResizeDetectorMaker = require('element-resize-detector');
var ResizeObserverLite = (function () {
    function ResizeObserverLite(handler) {
        var _this = this;
        this.handler = handler;
        this.listenedElements = [];
        this.hasResizeObserver = typeof window.ResizeObserver !== 'undefined';
        if (!this.hasResizeObserver) {
            this.erd = elementResizeDetectorMaker({ strategy: 'scroll' });
        }
        else {
            this.rz = new ResizeObserver(function (entries) {
                _this.handler(getSize(entries[0].target));
            });
        }
    }
    ResizeObserverLite.prototype.observe = function (element) {
        var _this = this;
        if (!this.hasResizeObserver) {
            this.erd.listenTo(element, function (element) {
                _this.handler(getSize(element));
            });
            this.listenedElements.push(element);
        }
        else {
            this.rz.observe(element);
        }
    };
    ResizeObserverLite.prototype.disconnect = function () {
        if (!this.hasResizeObserver) {
            for (var _i = 0, _a = this.listenedElements; _i < _a.length; _i++) {
                var element = _a[_i];
                this.erd.uninstall(element);
            }
            this.listenedElements = [];
        }
        else {
            this.rz.disconnect();
        }
    };
    return ResizeObserverLite;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ResizeObserverLite;
function getSize(element) {
    return {
        width: getNumber(window.getComputedStyle(element)['width']),
        height: getNumber(window.getComputedStyle(element)['height'])
    };
}
function getNumber(str) {
    var m = /^([0-9\.]+)px$/.exec(str);
    return m ? parseFloat(m[1]) : 0;
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/resize-observer-lite/lib/index.js
// module id = 167
// module chunks = 0